export const CONFIG = {
    // For Australia
    IsMapbox: false,
    API_URL: 'https://apioptimize.stortrack.com/api/',
    GoogleMapsApiKey: 'AIzaSyDmD4dBIX3AYtW4iej8okdDNKoto4fiqG4',//'AIzaSyCOyKBa2o4id-dopwQo7jGfVNtD0KJArXM',
    REACT_APP_MAPBOX_TOKEN: "pk.eyJ1IjoiY2xvdWRzdXBwb3J0IiwiYSI6ImNrcDd6MzllZzA1N2IzMW9oNTcwOHh0ajAifQ.C2VDAibO99HHvq7_YluMmw",
    STK_URL: 'https://au.stortrack.com/',
    OPTZ_URL: 'https://optimizeau.stortrack.com/',
    STK_SIGNURL: 'https://au.stortrack.com/Signin.html',
        USA_URL: 'https://www.stortrack.com/',
    AU_URL: 'https://au.stortrack.com/',
    NZ_URL:'https://nz.stortrack.com/',
    UK_URL: 'https://www.stortrack.co.uk/',
    RegionId: 2,
        Country_Code:'AU',
    Currency_Symbol: 'A$',    
    PhoneMaxLength: 20,
    PhoneMinLength: 4,
    PhoneRegex: /^([^\s]{3})([^\s]{4})([^\s]{4})$/g,    
    Mail_Support: 'AUsupport@stortrack.com',     
    STK_Homeurl: 'au.stortrack.com',    
    Mail_Info: 'info@stortrack.com',
    MapQuestKey_URL: 'https://www.mapquestapi.com/search/v2/radius?key=',
    MapQuestKey: 'YACBPORLjPNwG22g0A16czmgreWVIaGM',
    Toll_Free: '1-800-969-7424',    
    Sales_Support: '+61 3 9016 9281',
        Address1: "Street Address",
    Address2: "Address Line 2",
    City: "Town/City",
    State: "State/Territory",
    PostalCode: "Postal Code",
    Country: "Country",
        MeasurementLabel: "Total Square Metre",
        MeasurementName: "Square Metre",
        MeasurementShortName: "sqm",
        PostalCodevalidation :"Postal Code is invalid",        
        Website_Text_Footer_Pdf: 'optimizeau.stortrack.com',
    Website_URL_Footer_Pdf: 'https://optimizeau.stortrack.com/',
    Phone_Footer_Pdf: '1-800-969-7424',
    Mail_Footer_Pdf: 'info@stortrack.com',
        storeNameMaxLimit: 90,
        MVP_URL: 'https://explorer.stortrack.com/logins/',        
        REPORTS_URL:'https://reports.stortrack.com',
    ResourcePage:'https://www.stortrack.com/news',
        TimeOut_Sec: 1800
}
export const MatchingCountryCode = {
  UK_RID : 3,
  NZ_RID : 4,
};